import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../services/api/axios";
import { useUser } from "../../context/UserContext";
import { Typography, Card, CardBody, Button, Chip } from "@material-tailwind/react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Download } from "lucide-react";
import { FaFilePdf } from "react-icons/fa";
import { Spinner } from "@material-tailwind/react";
import { Upload, FileText } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUserById } from "../../services/users";
import ImageCarousel from "../../components/ImageCarousel";
import { pascalToSentenceCase } from "../../utils/helpers";
import { getMediaUrl, mapMediaItems } from "../../utils/media";

function PropertyUserView() {
  const location = useLocation();
  const { property } = location.state;
  const { saleDetails } = property;
  const { userInfo } = useUser();
  const [activeTab, setActiveTab] = useState("project");
  const [installments, setInstallments] = useState([]);
  const [mediaImages, setMediaImages] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isFinalAgreementRadio, setIsFinalAgreementRadio] = useState(false);
  const [tokenReceipts, setTokenReceipts] = useState([]);
  const [paymentReceipts, setPaymentReceipts] = useState([]);
  const [demandLetters, setDemandLetters] = useState([]);
  const [cancellationDocs, setCancellationDocs] = useState([]);
  const [handoverDocsSigned, setHandoverDocsSigned] = useState([]);
  const [handoverDocsUnsigned, setHandoverDocsUnsigned] = useState([]);
  const [occupancyDocs, setOccupancyDocs] = useState([]);
  const [costSheetDocs, setCostSheetDocs] = useState([]);
  const [finalAgreementFiles, setFinalAgreementFiles] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [bookingLetters, setBookingLetters] = useState([]);
  const [cancellationDocsSigned, setCancellationDocsSigned] = useState([]);
  const [cancellationDocsUnsigned, setCancellationDocsUnsigned] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [aadharNo, setAadharNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [uploading, setUploading] = useState(false);
  const [secondaryUsers, setSecondaryUsers] = useState([]);
  const [aadharPanData, setAadharPanData] = useState({});
  const [agreementFiles, setAgreementFiles] = useState([]);
  const [generating, setGenerating] = useState(false);
  const [fetchingAgreements, setFetchingAgreements] = useState(false);
  console.log("pro", property);
  useEffect(() => {
    const fetchInstallments = async () => {
      if (saleDetails) {
        try {
          const installResponse = await axiosInstance.get(
            "/customer/sales/installment",
            {
              params: {
                customer_sales_id: saleDetails.customerSalesId,
              },
            }
          );
          setInstallments(installResponse);
        } catch (error) {
          console.error("Error fetching installments:", error);
          setInstallments([]);
        }
      }
    };
    if (activeTab === "payments") {
      fetchInstallments();
    }

    const fetchImages = async () => {
      if (property?.project?.projectId) {
        try {
          const response = await axiosInstance.get("/projects/media", {
            params: {
              project_id: property.project.projectId,
              images: true,
            },
          });
          setMediaImages(mapMediaItems(response, "Project Image"));
        } catch (error) {
          console.error("Error fetching media images:", error);
        }
      }
    };

    fetchImages();
    if (activeTab === "receipts") {
      fetchReceipts(true);
      fetchReceipts(false);
      fetchCancellationDocs();
      fetchBookingLetters();
      fetchCostSheetDocs();
      fetchHandoverDocs();
      fetchFinalAgreements();
      fetchAgreements();
    }
  }, [userInfo, saleDetails, activeTab, property?.project?.projectId]);




  const handleFileClick = (file) => {
    setSelectedFile(file);
    setPdfUrl(getMediaUrl(file));
  };
  const downloadFile = async (file) => {
    const downloadUrl = getMediaUrl(file);
    if (!downloadUrl) {
      return;
    }

    const filename =
      file?.name || file?.key?.split("/").pop() || "document.pdf";

    try {
      const response = await fetch(downloadUrl);
      if (!response.ok) {
        window.open(downloadUrl, "_blank", "noopener,noreferrer");
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading file:", error);
      window.open(downloadUrl, "_blank", "noopener,noreferrer");
    }
  };


  const projectDetails = {
    projectName: property?.project?.projectName || "N/A",
    buildingName: property?.project?.buildingName || "N/A",
    address: property?.project?.address || {},
    unit: property?.project?.unit || "N/A",
    configSize: property?.project?.configSize || "N/A",
    amenities: property?.project?.amenities || "N/A",
    basePrice: property?.project?.basePrice || "N/A",
    dryBalconyArea: property?.project?.dryBalconyArea || "N/A",
    developer: property?.project?.developer || "N/A",
    towers: property?.project?.towers || "N/A",
    sizeAcres: property?.project?.sizeAcres || "N/A",
    location: property?.project?.location || "N/A",
    specifications: property?.project?.specifications || "N/A",
    units: property?.project?.units || "N/A",
    reraNo: property?.project?.reraNo || "N/A",
  };

  const parseAmenities = (amenitiesString) => {
    if (!amenitiesString) return [];
    return amenitiesString.split(",").map((amenity) => amenity.trim());
  };
  const amenitiesList = parseAmenities(projectDetails.amenities);

  const addressString = `${projectDetails.address?.buildingNo || ""} ${projectDetails.address?.streetName1 || ""
    } ${projectDetails.address?.streetName2 || ""}, ${projectDetails.address?.city || ""
    }, ${projectDetails.address?.district || ""}, ${projectDetails.address?.state || ""
    } - ${projectDetails.address?.pinCode || ""}, ${projectDetails.address?.country || ""
    }`.replace(/  +/g, ' ').trim();
  const openModal = async () => {
    if (saleDetails?.secondaryUsersId && saleDetails.secondaryUsersId.length > 0) {
      await fetchSecondaryUsers();
    } else {
      setSecondaryUsers([]);
      setAadharPanData({});
    }
    setModalIsOpen(true);
  };
  const closeModal = () => setModalIsOpen(false);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleFinalAgreementRadioChange = (e) => {
    setIsFinalAgreementRadio(e.target.value === "yes");
  };
  const fetchSecondaryUsers = async () => {
    if (saleDetails?.secondaryUsersId && saleDetails.secondaryUsersId.length > 0) {
      try {
        const userPromises = saleDetails.secondaryUsersId.map(async (userId) => {
          const response = await getUserById(userId);
          return response;
        });
        const userDetails = await Promise.all(userPromises);
        setSecondaryUsers(userDetails);
        const initialAadharPanData = {};
        userDetails.forEach((user) => {
          initialAadharPanData[user.userId] = { aadharNo: "", panNo: "" };
        });
        setAadharPanData(initialAadharPanData);
      } catch (error) {
        console.error("Failed to fetch secondary users:", error);
        toast.error("Failed to fetch secondary users");
      }
    } else {
      setSecondaryUsers([]);
      setAadharPanData({});
    }
  };

  const handleInputChange = (userId, field, value) => {
    setAadharPanData((prevData) => ({
      ...prevData,
      [userId]: {
        ...prevData[userId],
        [field]: value,
      },
    }));
  };
  const handleGenerateDraft = async () => {
    setGenerating(true);
    try {
      const secondaryUsersDetail = secondaryUsers.map((userArray) => {
        const user = userArray[0];
        return {
          user: {
            firstName: user.firstName,
            lastName: user.lastName,
            mobileNoWa: user.mobileNoWa,
            mobileNoCalling: user.mobileNoCalling,
            emailId: user.emailId,
            address: user.address,
            gender: user.gender,
            title: user.title,
            dob: user.dob,
          },
          aadharNo: aadharPanData[user.userId]?.aadharNo || "",
          panNo: aadharPanData[user.userId]?.panNo || "",
        };
      });

      const payload = {
        primaryUserDetail: {
          user: {
            firstName: saleDetails?.user?.firstName,
            lastName: saleDetails?.user?.lastName,
            mobileNoWa: saleDetails?.user?.mobileNoWa,
            mobileNoCalling: saleDetails?.user?.mobileNoCalling,
            emailId: saleDetails?.user?.emailId,
            address: saleDetails?.user?.address,
            gender: saleDetails?.user?.gender,
            title: saleDetails?.user?.title,
            dob: saleDetails?.user?.dob,
          },
          aadharNo: aadharNo,
          panNo: panNo,
        },
        secondaryUsersDetail: secondaryUsersDetail,
      };

      const response = await axiosInstance.post(
        `/customer/sales/draft-agreement?customerSalesId=${saleDetails.customerSalesId}`,
        payload
      );

      console.log("response", response);
      // Handle the success. you can trigger a download with response
      toast.success("Agreement generated successfully");
      closeModal();
    } catch (error) {
      console.error("Error generating draft:", error);
      toast.error(error.message || "Failed to generate the draft agreement");
    } finally {
      setGenerating(false);
    }
  };


  const tabsData = [
    {
      label: "Project",
      value: "project",
      content: (
        <div>
          <Typography
            variant="h4"
            className="font-semibold mb-2 sm:mb-4 text-center text-lg sm:text-xl"
          >
            Project Details
          </Typography>
          <div>
            {mediaImages?.length > 0 ? (
              <ImageCarousel images={mediaImages} />
            ) : (
              <div className="flex justify-center items-center p-4 sm:p-8">
                <p className="text-gray-500">No Images Available</p>
              </div>
            )}
          </div>
          <h2 className="text-lg font-semibold mb-2 sm:mb-4 text-center sm:text-lg">
            {projectDetails.projectName}
          </h2>
          <div className="text-sm text-gray-600 space-y-2 sm:space-y-4">
            <div className="flex flex-col lg:flex-row gap-2 sm:gap-6">
              {/* Left Column */}
              <div className="flex-1">
                <div className="p-2 sm:p-4 space-y-2 sm:space-y-4">
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      Developer:
                    </label>
                    <p className="text-sm sm:text-base">
                      {projectDetails.developer}
                    </p>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      Location:
                    </label>
                    <p className="text-sm sm:text-base">
                      {projectDetails.location}
                    </p>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      RERA No:
                    </label>
                    <p className="text-sm sm:text-base">
                      {projectDetails.reraNo}
                    </p>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      Specifications:
                    </label>
                    <p className="text-sm sm:text-base">
                    <div dangerouslySetInnerHTML={{ __html: projectDetails.specifications }} />
                    </p>
                  </div>
                </div>
              </div>
              {/* Right Column */}
              <div className="w-full lg:w-1/3">
                <div className=" p-2 sm:p-4 space-y-2 sm:space-y-4">
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      Size:
                    </label>
                    <p className="text-sm sm:text-base">
                      {projectDetails.sizeAcres} acres
                    </p>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      Towers:
                    </label>
                    <p className="text-sm sm:text-base">
                      {projectDetails.towers}
                    </p>
                  </div>
                  <div>
                    <label className="font-medium text-gray-700 text-sm sm:text-base">
                      Units:
                    </label>
                    <p className="text-sm sm:text-base">
                      {projectDetails.units}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 sm:mt-6">
            <Typography variant="h6" className="mb-1 sm:mb-2 text-sm sm:text-base">
              Address
            </Typography>
            <p className="text-sm sm:text-base">{addressString}</p>
          </div>
          <div className="mt-4 sm:mt-6 space-x-3">
            <Typography variant="h6" className="mb-1 sm:mb-2 text-sm sm:text-base">
              Amenities
            </Typography>

            {amenitiesList.map((amenity, index) => (
              <Chip
                variant="outline"
                className="py-1 px-2 rounded-md text-sm"
                color="black"
                key={index} // Added key prop here
              >
                {pascalToSentenceCase(amenity)}
              </Chip>
            ))}

          </div>
        </div>
      ),
    },
    {
      label: "Payments",
      value: "payments",
      content: (
        <div className="w-full max-w-lg mx-auto bg-white rounded-xl shadow p-6">
          {/* Tab Row */}
          <div className="flex border-b mb-6">
            {[
              { label: "Project Details", value: "project" },
              { label: "Payments", value: "payments" },
              { label: "Documents", value: "receipts" },
            ].map((tab) => (
              <button
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`flex-1 py-2 text-center font-medium text-base transition-colors duration-200 ${
                  activeTab === tab.value
                    ? "text-blue-600 border-b-2 border-blue-600 bg-blue-50"
                    : "text-gray-500 border-b-2 border-transparent"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Payment Information */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-blue-700 mb-2">Payment Information</h3>
            <div className="space-y-1 text-gray-800 text-sm">
              <div><span className="font-semibold">Property:</span> {property?.project?.configName || property?.project?.projectName || "N/A"}, {property?.project?.address?.streetName1 || ""} {property?.project?.address?.city || ""}</div>
              <div><span className="font-semibold">Total Price:</span> ₹{saleDetails?.basePrice || "N/A"}</div>
              <div><span className="font-semibold">Amount Paid:</span> ₹{saleDetails?.amountPaid || "N/A"}</div>
              <div><span className="font-semibold">Remaining Balance:</span> ₹{saleDetails?.remainingBalance || "N/A"}</div>
            </div>
          </div>

          {/* Installment History */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-blue-700 mb-2">Installment History</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm border">
                <thead>
                  <tr className="bg-orange-500 text-white">
                    <th className="px-3 py-2">Installment</th>
                    <th className="px-3 py-2">Due Date</th>
                    <th className="px-3 py-2">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {installments.length > 0 ? (
                    installments.map((inst, idx) => (
                      <tr key={idx} className="border-b last:border-b-0">
                        <td className="px-3 py-2">Installment {idx + 1}</td>
                        <td className="px-3 py-2">{inst.projectedDate || "N/A"}</td>
                        <td className="px-3 py-2">
                          {inst.status === "Paid" || inst.statusType?.typeName === "Paid" ? (
                            <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-semibold">Paid</span>
                          ) : (
                            <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-semibold">Due</span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center py-4 text-gray-400">No Installments found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Upcoming Due Dates */}
          <div className="mb-2">
            <h3 className="text-lg font-semibold text-blue-700 mb-2">Upcoming Due Dates</h3>
            {/* Find the next due installment */}
            {(() => {
              const nextDue = installments.find(
                (inst) => (inst.status !== "Paid" && inst.statusType?.typeName !== "Paid")
              );
              if (nextDue) {
                const idx = installments.indexOf(nextDue) + 1;
                return (
                  <div className="flex items-center gap-2 text-base">
                    <span className="text-gray-700">Next Installment Due:</span>
                    <span className="font-semibold">Installment No. {idx}:</span>
                    <span className="font-bold text-lg">₹{nextDue.projectedAmount || "N/A"}</span>
                    <span className="text-blue-600 font-medium">{nextDue.projectedDate || "N/A"}</span>
                  </div>
                );
              } else {
                return <div className="text-gray-500 text-sm">No upcoming dues.</div>;
              }
            })()}
          </div>
        </div>
      ),
    },
    {
      label: "Receipts",
      value: "receipts",
      content: (
        <div className="flex flex-col lg:flex-row">
          <div className="space-y-2 flex-1 p-4">
            {loading ? <div className="flex justify-center items-center h-40"><div role="status">
              <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
              <span class="sr-only">Loading...</span>
            </div></div> :
              <>
                <h2 className="text-xl font-medium text-base sm:text-lg">Token Receipts</h2>
                <div className="space-y-2">
                  {tokenReceipts?.map((file) => (
                    <Card key={file.key} className="p-2 mb-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <FaFilePdf className="text-blue-600 text-xl" />
                          <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                        </div>
                        <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                          <Download className="h-4 w-4" />
                        </Button>
                      </div>
                    </Card>
                  ))}
                </div>
                <h3 className="text-xl font-medium text-base sm:text-lg">Payment Receipts</h3>
                <div className="space-y-2">
                  {paymentReceipts?.map((file) => (
                    <Card key={file.key} className="p-2 mb-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <FaFilePdf className="text-green-600 text-xl" />
                          <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                        </div>
                        <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                          <Download className="h-4 w-4" />
                        </Button>
                      </div>
                    </Card>
                  ))}
                </div>
                <h3 className="text-xl font-medium mb-4 text-base sm:text-lg">Demand Letters</h3>
                <div className="space-y-2">
                  {demandLetters?.map((file) => (
                    <Card key={file.key} className="p-2 mb-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <FaFilePdf className="text-yellow-600 text-xl" />
                          <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                        </div>
                        <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                          <Download className="h-4 w-4" />
                        </Button>
                      </div>
                    </Card>
                  ))}
                </div>
                <h4 className="text-xl font-medium mb-4 text-base sm:text-lg">Booking Letter</h4>
                <div className="space-y-2">
                  {bookingLetters?.map((file) => (
                    <Card key={file.key} className="p-2 mb-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <FaFilePdf className="text-purple-600 text-xl" />
                          <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                        </div>
                        <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                          <Download className="h-4 w-4" />
                        </Button>
                      </div>
                    </Card>
                  ))}
                </div>
                {/* Conditional rendering for cancellation documents */}
                {(cancellationDocsSigned && cancellationDocsSigned.length > 0) || (cancellationDocsUnsigned && cancellationDocsUnsigned.length > 0) ? (
                  <>
                    <h3 className="font-medium text-xl text-base sm:text-lg">Cancellation Documents</h3>
                    <div className="space-y-2">
                      {cancellationDocsSigned && cancellationDocsSigned.length > 0 && (
                        <>
                          <h5 className="font-normal mt-4 text-sm sm:text-base">Signed</h5>
                          {cancellationDocsSigned.map((file) => (
                            <Card key={file.key} className="p-2 mb-2">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                  <FaFilePdf className="text-red-600 text-xl" />
                                  <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                                </div>
                                <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                                  <Download className="h-4 w-4" />
                                </Button>
                              </div>
                            </Card>
                          ))}
                        </>
                      )}
                      {cancellationDocsUnsigned && cancellationDocsUnsigned.length > 0 && (
                        <>
                          <h5 className="font-normal mt-4 text-sm sm:text-base">Unsigned</h5>
                          {cancellationDocsUnsigned.map((file) => (<Card key={file.key} className="p-2 mb-2">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-2">
                                <FaFilePdf className="text-red-600 text-xl" />
                                <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                              </div>
                              <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                                <Download className="h-4 w-4" />
                              </Button>
                            </div>
                          </Card>
                          ))}
                        </>
                      )}
                    </div>
                  </>
                ) : null}
                <h3 className="font-medium text-base sm:text-lg">Handover Documents</h3>
                <div className="space-y-2">
                  <h5 className="font-normal mt-4 text-sm sm:text-base">Signed</h5>
                  <div className="space-y-2">
                    {handoverDocsSigned?.map((file) => (
                      <Card key={file.key} className="p-2 mb-2">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <FaFilePdf className="text-indigo-600 text-xl" />
                            <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                          </div>
                          <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                            <Download className="h-4 w-4" />
                          </Button>
                        </div>
                      </Card>
                    ))}
                  </div>
                  <h5 className="font-normal mt-4 text-sm sm:text-base">Unsigned</h5>
                  <div className="space-y-2">
                    {handoverDocsUnsigned?.map((file) => (
                      <Card key={file.key} className="p-2 mb-2">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <FaFilePdf className="text-indigo-600 text-xl" />
                            <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                          </div>
                          <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                            <Download className="h-4 w-4" />
                          </Button>
                        </div>
                      </Card>
                    ))}
                  </div>
                </div>
                <h3 className="font-medium text-base sm:text-lg">Cost Sheets</h3>
                <div className="space-y-2">
                  {costSheetDocs?.map((file) => (
                    <Card key={file.key} className="p-2 mb-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <FaFilePdf className="text-gray-600 text-xl" />
                          <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                        </div>
                        <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                          <Download className="h-4 w-4" />
                        </Button>
                      </div>
                    </Card>
                  ))}
                </div>
                <h3 className="font-medium text-base sm:text-lg">Final Agreements</h3>
                <div className="space-y-2">
                  {finalAgreementFiles && finalAgreementFiles.length > 0 ?
                    (finalAgreementFiles?.map((file) => (
                      <Card key={file.key} className="p-2 mb-2">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <FaFilePdf className="text-gray-600 text-xl" />
                            <Typography variant="small" className="font-normal text-sm sm:text-base"> {file.key}</Typography>
                          </div>
                          <Button size="sm" onClick={() => downloadFile(file)} className="flex items-center gap-2 bg-accent text-sm sm:text-base">
                            <Download className="h-4 w-4" />
                          </Button>
                        </div>
                      </Card>
                    )))
                    : (<div className="p-4">No final agreements uploaded yet</div>)}
                </div>
                <h3 className="font-medium text-base sm:text-lg">Draft Agreements</h3>
                <div className="space-y-2">
                  {agreementFiles && agreementFiles.length > 0 ?
                    agreementFiles.map((file, index) => (
                      <div key={index} className="border border-gray-300 rounded p-4 flex items-center gap-2 w-60">
                        <FileText className="text-gray-600" size={24} />
                        <div>
                          <p className="text-sm font-medium text-gray-800"> {`Agreement ${index + 1}`} </p>
                          <a href={file.url} target="_blank" rel="noopener noreferrer"
                            className="text-blue-600 text-xs "
                          >
                            Download
                          </a>
                        </div>
                      </div>
                    )) : (<div className="p-4">No draft agreements uploaded yet</div>)}

                </div>
              </>
            }
          </div>
          {/*<div className="w-full lg:w-1/3 p-4">*/}
          {/*        {pdfUrl && selectedFile ? (*/}
          {/*                <div className="bg-gray-50 p-4 rounded-lg shadow-md">*/}
          {/*                     <div className="flex items-center justify-between mb-4">*/}
          {/*                        <h4 className="font-semibold">{selectedFile.key}</h4>*/}
          {/*                         <Button*/}
          {/*                            onClick={()=>downloadFile(selectedFile)}*/}
          {/*                            size="sm"*/}
          {/*                            className="flex items-center gap-2 bg-accent"*/}
          {/*                          >*/}
          {/*                                <Download className="h-4 w-4" />*/}
          {/*                                Download*/}
          {/*                         </Button>*/}
          {/*                     </div>*/}
          {/*                      <div className="border p-4 rounded mt-4">*/}
          {/*                        <iframe*/}
          {/*                            src={pdfUrl}*/}
          {/*                            title="PDF Preview"*/}
          {/*                            width="100%"*/}
          {/*                            height="500px"*/}
          {/*                            style={{ border: "none" }}*/}
          {/*                        />*/}
          {/*                       </div>*/}
          {/*                 </div>*/}
          {/*                ) : (*/}
          {/*                <div className="bg-gray-50 p-4 rounded-lg shadow-md flex items-center justify-center h-96">*/}
          {/*                    <p>Select a document to preview</p>*/}
          {/*                </div>*/}
          {/*            )}*/}
          {/*            </div>*/}
        </div>
      ),
    },
  ];

  const fetchReceipts = async (isToken) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/customer/sales/receipts", {
        params: {
          customer_sales_id: saleDetails.customerSalesId,
          isToken: isToken,
        },
      });
      console.log("token or pay", response);
      const formattedFiles = mapMediaItems(
        response,
        isToken ? "Token Receipt" : "Payment Receipt"
      );
      if (isToken) {
        setTokenReceipts(formattedFiles);
      } else {
        setPaymentReceipts(formattedFiles);
      }
    } catch (error) {
      console.error("Error fetching receipts:", error);
    }
    finally {
      setLoading(false);
    }
  };
  const fetchCancellationDocs = async () => {
    setLoading(true);
    try {
      const signedResponse = await axiosInstance.get(
        "/customer/sales/cancellation-letters",
        {
          params: {
            customer_sales_id: saleDetails.customerSalesId,
            isSigned: true,
          },
        }
      );
      const unsignedResponse = await axiosInstance.get(
        "/customer/sales/cancellation-letters",
        {
          params: {
            customer_sales_id: saleDetails.customerSalesId,
            isSigned: false,
          },
        }
      );
      console.log("cancellation docs signed", signedResponse);
      console.log("cancellation docs unsigned", unsignedResponse);
      setCancellationDocsSigned(
        mapMediaItems(signedResponse, "Cancellation Signed")
      );
      setCancellationDocsUnsigned(
        mapMediaItems(unsignedResponse, "Cancellation Unsigned")
      );

    }
    catch (error) {
      console.log("Error fetching cancellation docs", error)
    }
    finally {
      setLoading(false);
    }
  }

  const fetchBookingLetters = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/customer/sales/booking-letters", {
        params: {
          customer_sales_id: saleDetails.customerSalesId,
        },
      });
      console.log("booking docs signed", response);
      setBookingLetters(mapMediaItems(response, "Booking Letter"));
    } catch (error) {
      console.error("Error fetching booking documents:", error);
    }
    finally {
      setLoading(false);
    }
  };
  const fetchHandoverDocs = async () => {
    setLoading(true);
    try {
      const signedResponse = await axiosInstance.get(
        "/customer/sales/handover-letters",
        {
          params: {
            customer_sales_id: saleDetails.customerSalesId,
            isSigned: true,
          },
        }
      );
      const unsignedResponse = await axiosInstance.get(
        "/customer/sales/handover-letters",
        {
          params: {
            customer_sales_id: saleDetails.customerSalesId,
            isSigned: false,
          },
        }
      );
      console.log("handover docs signed", signedResponse);
      console.log("handover docs unsigned", unsignedResponse);
      setHandoverDocsSigned(
        mapMediaItems(signedResponse, "Handover Signed")
      );
      setHandoverDocsUnsigned(
        mapMediaItems(unsignedResponse, "Handover Unsigned")
      );
    }
    catch (error) {
      console.log("Error fetching handover docs", error)
    }
    finally {
      setLoading(false);
    }
  }
  const fetchCostSheetDocs = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/customer/sales/cost-sheet", {
        params: {
          customer_sales_id: saleDetails.customerSalesId,
        },
      });
      setCostSheetDocs(mapMediaItems(response, "Cost Sheet"));
    } catch (error) {
      console.error("Error fetching cost sheet documents:", error);
    }
    finally {
      setLoading(false);
    }
  };
  const fetchFinalAgreements = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/customer/sales/agreement", {
        params: {
          customer_sales_id: saleDetails.customerSalesId,
          isFinal: true,
        },
      });
      console.log("agreement doc", response);
      setFinalAgreementFiles(mapMediaItems(response, "Final Agreement"));
    } catch (e) {
      console.log("Error fetching the agreement", e)
    } finally {
      setLoading(false)
    }
  }
  const fetchAgreements = async () => {
    if (!property?.project?.projectId) {
      return;
    }

    setFetchingAgreements(true);
    try {
      const response = await axiosInstance.get(
        `/projects/media?project_id=${property?.project?.projectId}&agreement=true`
      );
      console.log("agreement response ", response);

      // Map over the response array to extract name and create the URL
      const processedFiles = mapMediaItems(response, "Agreement").map(
        (item, index) => ({
          ...item,
          name: item.name || `Agreement ${index + 1}`,
        })
      );
      setAgreementFiles(processedFiles);
    } catch (error) {
      console.error("Failed to fetch agreement files:", error);

    } finally {
      setFetchingAgreements(false);
    }
  };
  const buttonStyle = (isDisabled) => ({
    backgroundColor: isDisabled ? "#ddd" : null,
    color: isDisabled ? "#999" : "white",
    cursor: isDisabled ? "not-allowed" : "pointer",
    opacity: isDisabled ? 0.7 : 1,
    pointerEvents: isDisabled ? "none" : "auto",
  });
  return (
    <div className="container mx-auto p-4 sm:p-6">

      <Typography variant="h2" className="font-bold mb-4 sm:mb-6 text-center">
        Property Details
      </Typography>
      <div className="relative">
        <div className="flex justify-around border-b border-gray-300">
          {tabsData.map(({ label, value }, index) => (
            <button
              key={value}
              onClick={() => setActiveTab(value)}
              className={`flex-1 text-center py-3 text-sm sm:text-base relative ${activeTab === value
                ? "text-black-200 font-normal"
                : "text-gray-600"
                }`}
            >
              {label}
              {activeTab === value && (
                <span
                  className="absolute bottom-0 left-0 right-0 h-1 bg-accent"
                  style={{
                    transition: "width 0.3s ease-in-out",
                  }}
                />
              )}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-4">
        <Card className="p-4 rounded-lg">
          <CardBody>
            {tabsData.find((item) => item.value === activeTab)?.content || (
              <p>Select a tab to view details.</p>
            )}
          </CardBody>
        </Card>
      </div>
      {modalIsOpen && (
        <div style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            width: "100%",
            height: "100%",
          },
          content: {
            position: "fixed",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "12px",
            maxHeight: "90vh",
            overflowY: "auto",
            maxWidth: "95vw",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        }}>
          <div style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "12px",
            maxHeight: "90vh",
            overflowY: "auto",
            maxWidth: "95vw",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}>
            <div className="flex justify-between items-start mb-6">
              <h2 className="text-2xl font-semibold text-gray-800">Draft Agreement Details</h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Primary User Section */}
            <div className="mb-8">
              <h3 className="text-xl font-semibold mb-4 text-gray-700">Primary User Details</h3>
              <div className="mb-4">
                <label className="block text-gray-600 text-sm font-medium mb-2">Name</label>
                <p className="font-medium text-gray-800">{saleDetails?.user?.firstName} {saleDetails?.user?.lastName} {saleDetails?.user?.title}</p>
              </div>
              <div className="mb-4">
                <label htmlFor="aadharNo" className="block text-gray-600 text-sm font-medium mb-2">Aadhar No</label>
                <input
                  type="text"
                  id="aadharNo"
                  value={aadharNo}
                  onChange={(e) => setAadharNo(e.target.value)}
                  placeholder="Enter Aadhar Number"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="panNo" className="block text-gray-600 text-sm font-medium mb-2">Pan No</label>
                <input
                  type="text"
                  id="panNo"
                  value={panNo}
                  onChange={(e) => setPanNo(e.target.value)}
                  placeholder="Enter Pan Number"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>

            {/* Secondary Users Section */}
            {secondaryUsers && secondaryUsers.length > 0 && (
              <div className="mb-8">
                <h3 className="text-xl font-semibold mb-4 text-gray-700">Secondary Users Details</h3>
                <div className="flex flex-wrap -mx-4">
                  {secondaryUsers.map((userArray, index) => {
                    const user = userArray[0];
                    return (
                      <div key={user.userId} className="mb-6 p-4 border rounded border-gray-200 w-1/2 px-4">
                        <p className="font-medium text-gray-800 mb-3 text-sm">
                          {user.title} {user.firstName} {user.lastName}
                        </p>
                        <div className="mb-3">
                          <label htmlFor={`aadharNo-${user.userId}`} className="block text-gray-600 text-xs font-medium mb-1">Aadhar No</label>
                          <input
                            type="text"
                            id={`aadharNo-${user.userId}`}
                            placeholder="Enter Aadhar Number"
                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-xs"
                            value={aadharPanData[user.userId]?.aadharNo || ""}
                            onChange={(e) => handleInputChange(user.userId, 'aadharNo', e.target.value)}
                          />
                        </div>
                        <div>
                          <label htmlFor={`panNo-${user.userId}`} className="block text-gray-600 text-xs font-medium mb-1">Pan No</label>
                          <input
                            type="text"
                            id={`panNo-${user.userId}`}
                            placeholder="Enter Pan Number"
                            className="shadow appearance-none border rounded w-full py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-xs"
                            value={aadharPanData[user.userId]?.panNo || ""}
                            onChange={(e) => handleInputChange(user.userId, 'panNo', e.target.value)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="text-right mt-6 flex justify-end gap-4">
              <button
                className="bg-gray-400 hover:bg-gray-500 text-white  text-sm font-medium py-2 px-4 rounded"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                onClick={handleGenerateDraft}
                disabled={generating}
                className={`bg-green-700 hover:bg-green-800 text-sm text-white font-medium py-2 px-4 rounded ${generating ? "opacity-50 cursor-not-allowed" : ""
                  }`}
              >
                {generating ? "Generating..." : "Generate and Download"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default PropertyUserView;